import Vue from 'vue';
import defaultState from './defaultState';
import * as C from '../constants';

export default {

  /**
   * @param state
   */
  [C.ITINERARY_CLEAR_STATE](state) {
    Object.assign(state, defaultState());
  },

  /**
   * @param state
   */
  [C.ITINERARY_PRODUCT_TYPES_PENDING](state) {
    Vue.set(state, 'productTypes', {
      loading: true,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_PRODUCT_TYPES_SUCCESS](state, payload) {
    Vue.set(state, 'productTypes', {
      loading: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_PRODUCT_TYPES_FAILURE](state) {
    Vue.set(state, 'productTypes', {
      loading: false,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_OVERVIEW_PENDING](state) {
    Vue.set(state, 'overview', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_OVERVIEW_SUCCESS](state, payload) {
    Vue.set(state, 'overview', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_OVERVIEW_FAILURE](state) {
    Vue.set(state, 'overview', {
      loading: false,
      error: true,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_CREATE_PENDING](state) {
    Vue.set(state, 'create', {
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_CREATE_SUCCESS](state, payload) {
    Vue.set(state, 'create', {
      loading: false,
      error: false,
    });
    Vue.set(state, 'edit', {
      loading: false,
      error: false,
      item: payload,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_CREATE_FAILURE](state, payload) {
    Vue.set(state, 'create', {
      loading: false,
      error: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_LOAD_GENERAL_PENDING](state) {
    Vue.set(state, 'edit', {
      ...state.edit,
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_LOAD_GENERAL_SUCCESS](state, payload) {
    Vue.set(state, 'edit', {
      loading: false,
      error: false,
      item: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_LOAD_GENERAL_FAILURE](state) {
    Vue.set(state, 'edit', {
      ...state.edit,
      loading: false,
      error: true,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_EDIT_PENDING](state) {
    Vue.set(state, 'edit', {
      ...state.edit,
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_EDIT_SUCCESS](state, payload) {
    Vue.set(state, 'edit', {
      ...state.edit,
      loading: false,
      error: false,
      item: {
        ...state.edit.item,
        ...payload,
      },
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_EDIT_FAILURE](state, payload) {
    Vue.set(state, 'edit', {
      ...state.edit,
      loading: false,
      error: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_MASTER_COUNTRIES_PENDING](state) {
    Vue.set(state, 'masterCountries', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_MASTER_COUNTRIES_SUCCESS](state, payload) {
    Vue.set(state, 'masterCountries', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_MASTER_COUNTRIES_FAILURE](state) {
    Vue.set(state, 'masterCountries', {
      loading: false,
      error: true,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_SALES_COUNTRIES_PENDING](state) {
    Vue.set(state, 'salesCountries', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_SALES_COUNTRIES_SUCCESS](state, payload) {
    Vue.set(state, 'salesCountries', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_SALES_COUNTRIES_FAILURE](state, payload) {
    Vue.set(state, 'salesCountries', {
      loading: false,
      error: payload,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_SALES_COUNTRIES_UPDATE_PENDING](state) {
    Vue.set(state, 'salesCountries', {
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_SALES_COUNTRIES_UPDATE_SUCCESS](state) {
    Vue.set(state, 'salesCountries', {
      loading: false,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_SALES_COUNTRIES_UPDATE_FAILURE](state, payload) {
    Vue.set(state, 'salesCountries', {
      loading: false,
      error: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_TRIP_THEMES_PENDING](state) {
    Vue.set(state, 'tripThemes', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_TRIP_THEMES_SUCCESS](state, payload) {
    Vue.set(state, 'tripThemes', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_TRIP_THEMES_FAILURE](state) {
    Vue.set(state, 'tripThemes', {
      loading: false,
      error: true,
      items: [],
    });
  },


  /**
   * @param state
   */
  [C.ITINERARY_TRIP_THEMES_ASSIGNED_PENDING](state) {
    Vue.set(state, 'assignedTripThemes', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_TRIP_THEMES_ASSIGNED_SUCCESS](state, payload) {
    Vue.set(state, 'assignedTripThemes', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_TRIP_THEMES_ASSIGNED_FAILURE](state) {
    Vue.set(state, 'assignedTripThemes', {
      loading: false,
      error: true,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_TRIP_THEMES_UPDATE_PENDING](state) {
    Vue.set(state, 'assignedTripThemes', {
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_TRIP_THEMES_UPDATE_SUCCESS](state) {
    Vue.set(state, 'assignedTripThemes', {
      loading: false,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_TRIP_THEMES_UPDATE_FAILURE](state) {
    Vue.set(state, 'assignedTripThemes', {
      loading: false,
      error: true,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_PENDING](state) {
    Vue.set(state, 'dayProgram', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_SUCCESS](state, payload) {
    Vue.set(state, 'dayProgram', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_FAILURE](state) {
    Vue.set(state, 'dayProgram', {
      loading: false,
      error: true,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_NO_CONTENT](state) {
    Vue.set(state, 'dayProgram', {
      loading: false,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_ADD_PENDING](state) {
    Vue.set(state, 'dayProgram', {
      ...state.dayProgram,
      loading: true,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_ADD_SUCCESS](state, payload) {
    Vue.set(state, 'dayProgram', {
      ...state.dayProgram,
      loading: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_ADD_FAILURE](state) {
    Vue.set(state, 'dayProgram', {
      ...state.dayProgram,
      loading: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_DELETE_DAY_PENDING](state) {
    Vue.set(state, 'dayProgram', {
      ...state.dayProgram,
      loading: true,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_DELETE_DAY_SUCCESS](state, payload) {
    state.dayProgram.items.splice(payload, 1);
    Vue.set(state, 'dayProgram', {
      ...state.dayProgram,
      loading: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_DELETE_DAY_FAILURE](state) {
    Vue.set(state, 'dayProgram', {
      ...state.dayProgram,
      loading: false,
    });
  },


  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_UPDATE_PENDING](state) {
    Vue.set(state, 'dayProgram', {
      ...state.dayProgram,
      loading: true,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_UPDATE_SUCCESS](state, payload) {
    Vue.set(state, 'dayProgram', {
      ...state.dayProgram,
      items: payload.data,
      loading: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_UPDATE_FAILURE](state) {
    Vue.set(state, 'dayProgram', {
      ...state.dayProgram,
      loading: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_LOCATION_SET](state, payload) {
    Vue.set(state, 'dayProgramLocation', {
      ...state.dayProgramLocation,
      dayProgram: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_LOCATION_SAVE_PENDING](state) {
    Vue.set(state, 'dayProgramLocation', {
      ...state.dayProgramLocation,
      loading: true,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_LOCATION_SAVE_SUCCESS](state) {
    Vue.set(state, 'dayProgramLocation', {
      dayProgram: null,
      loading: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_LOCATION_SAVE_FAILURE](state) {
    Vue.set(state, 'dayProgramLocation', {
      ...state.dayProgramLocation,
      loading: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_LOCATION_UPDATE_DATA](state, payload) {
    Vue.set(state.dayProgram.items, payload.dayProgramIndex, {
      ...state.dayProgram.items[payload.dayProgramIndex],
      countryId: payload.countryId,
      country: payload.country,
      areaId: payload.areaId,
      area: payload.area,
      hotelCount: 0,
      excursionCount: 0,
      imageCount: 0,
      mealplanCount: 0,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_HOTEL_PENDING](state, payload) {
    Vue.set(state, 'dayProgramHotel', {
      loading: true,
      dayProgram: payload,
      hotelsByArea: [],
      selectedHotels: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_SET_AVAILABLE_HOTELS](state, payload) {
    Vue.set(state, 'dayProgramHotel', {
      ...state.dayProgramHotel,
      hotelsByArea: payload,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_SET_SELECTED_HOTELS](state, payload) {
    Vue.set(state, 'dayProgramHotel', {
      ...state.dayProgramHotel,
      selectedHotels: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_HOTEL_SET_LOADING](state) {
    Vue.set(state, 'dayProgramHotel', {
      ...state.dayProgramHotel,
      loading: true,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_HOTEL_CLEAR_LOADING](state) {
    Vue.set(state, 'dayProgramHotel', {
      ...state.dayProgramHotel,
      loading: false,
    });
  },

  /**
   * @param state
   * @param dayProgramIndex
   * @param hotelCount
   */
  [C.ITINERARY_DAY_PROGRAM_HOTEL_UPDATE_SUCCESS](state, { dayProgramIndex, hotelCount }) {
    Vue.set(state.dayProgram.items, dayProgramIndex, {
      ...state.dayProgram.items[dayProgramIndex],
      hotelCount,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_EXCURSIONS_PENDING](state, payload) {
    Vue.set(state, 'dayProgramExcursions', {
      loading: true,
      dayProgram: payload,
      excursions: [],
      selectedExcursionIds: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_EXCURSIONS_CLEAR_LOADING](state) {
    Vue.set(state, 'dayProgramExcursions', {
      ...state.dayProgramExcursions,
      loading: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_SET_AVAILABLE_EXCURSIONS](state, payload) {
    Vue.set(state, 'dayProgramExcursions', {
      ...state.dayProgramExcursions,
      excursions: payload,
      loading: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_EXCURSIONS_SET_LOADING](state) {
    Vue.set(state, 'dayProgramExcursions', {
      ...state.dayProgramExcursions,
      loading: true,
    });
  },

  /**
   * @param state
   * @param dayProgramIndex
   * @param hotelCount
   */
  [C.ITINERARY_DAY_PROGRAM_EXCURSIONS_UPDATE_SUCCESS](state, { dayProgramIndex, excursionCount, extras }) {
    Vue.set(state.dayProgram.items, dayProgramIndex, {
      ...state.dayProgram.items[dayProgramIndex],
      excursionCount,
      extras,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_MEAL_PLAN_TYPES_PENDING](state) {
    Vue.set(state, 'mealPlanTypes', {
      loading: true,
      error: false,
      types: [],
      options: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_MEAL_PLAN_TYPES_SUCCESS](state, payload) {
    Vue.set(state, 'mealPlanTypes', {
      loading: false,
      error: false,
      types: payload.types,
      options: payload.options,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_MEAL_PLAN_TYPES_FAILURE](state) {
    Vue.set(state, 'mealPlanTypes', {
      loading: false,
      error: true,
      types: [],
      options: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_MEAL_PLANS_PENDING](state, payload) {
    Vue.set(state, 'dayProgramMealPlans', {
      loading: true,
      error: false,
      dayProgram: payload,
      mealPlans: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_MEAL_PLANS_SUCCESS](state, payload) {
    Vue.set(state, 'dayProgramMealPlans', {
      ...state.dayProgramMealPlans,
      loading: false,
      error: false,
      mealPlans: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_MEAL_PLANS_FAILURE](state) {
    Vue.set(state, 'dayProgramMealPlans', {
      ...state.dayProgramMealPlans,
      loading: false,
      error: true,
      mealPlans: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_MEAL_PLANS_CLEAR_LOADING](state) {
    Vue.set(state, 'dayProgramMealPlans', {
      ...state.dayProgramMealPlans,
      loading: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_MEAL_PLANS_SET_LOADING](state) {
    Vue.set(state, 'dayProgramMealPlans', {
      ...state.dayProgramMealPlans,
      loading: true,
    });
  },

  /**
   * @param state
   * @param dayProgramIndex
   * @param mealplanCount
   */
  [C.ITINERARY_DAY_PROGRAM_MEAL_PLANS_UPDATE_SUCCESS](state, { dayProgramIndex, mealplanCount }) {
    Vue.set(state.dayProgram.items, dayProgramIndex, {
      ...state.dayProgram.items[dayProgramIndex],
      mealplanCount,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DOMAINS_PENDING](state) {
    Vue.set(state, 'domains', {
      ...state.domains,
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DOMAINS_SUCCESS](state, payload) {
    Vue.set(state, 'domains', {
      ...state.domains,
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DOMAINS_FAILURE](state) {
    Vue.set(state, 'domains', {
      ...state.domains,
      loading: false,
      error: true,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DOMAINS_NO_CONTENT](state) {
    Vue.set(state, 'domains', {
      ...state.domains,
      loading: false,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DOMAIN_SELECT](state, payload) {
    Vue.set(state, 'domains', {
      ...state.domains,
      selected: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DOMAIN_DESELECT](state) {
    Vue.set(state, 'domains', {
      ...state.domains,
      selected: null,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_IMAGES_PENDING](state) {
    Vue.set(state, 'dayProgramImages', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_IMAGES_SUCCESS](state, payload) {
    Vue.set(state, 'dayProgramImages', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_IMAGES_FAILURE](state) {
    Vue.set(state, 'dayProgramImages', {
      loading: false,
      error: true,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_IMAGES_SAVE_PENDING](state) {
    Vue.set(state, 'dayProgramImages', {
      ...state.dayProgramImages,
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_IMAGES_SAVE_SUCCESS](state) {
    Vue.set(state, 'dayProgramImages', {
      ...state.dayProgramImages,
      loading: false,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_IMAGES_SAVE_FAILURE](state) {
    Vue.set(state, 'dayProgramImages', {
      ...state.dayProgramImages,
      loading: false,
      error: true,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_TEASER_PENDING](state) {
    Vue.set(state, 'seoTeasers', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_TEASER_SUCCESS](state, payload) {
    Vue.set(state, 'seoTeasers', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_TEASER_FAILURE](state) {
    Vue.set(state, 'seoTeasers', {
      loading: false,
      error: true,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_TEASER_UPDATE_PENDING](state) {
    Vue.set(state, 'seoTeasers', {
      ...state.seoTeasers,
      loading: true,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_TEASER_UPDATE_SUCCESS](state, payload) {
    Vue.set(state, 'seoTeasers', {
      ...state.seoTeasers,
      items: payload.data,
      loading: false,
    });
  },

  [C.ITINERARY_PRICE_INTERVALS_GET_NO_CONTENT](state) {
    Vue.set(state, 'priceIntervals', {
      ...state.priceIntervals,
      loading: false,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_TEASER_UPDATE_FAILURE](state) {
    Vue.set(state, 'seoTeasers', {
      ...state.seoTeasers,
      loading: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_INCLUDE_PENDING](state) {
    Vue.set(state, 'includes', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_INCLUDE_SUCCESS](state, payload) {
    Vue.set(state, 'includes', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_INCLUDE_NO_CONTENT](state) {
    Vue.set(state, 'includes', {
      loading: false,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_INCLUDE_FAILURE](state) {
    Vue.set(state, 'includes', {
      loading: false,
      error: true,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_INCLUDE_UPDATE_PENDING](state) {
    Vue.set(state, 'includes', {
      ...state.includes,
      loading: true,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_INCLUDE_UPDATE_SUCCESS](state, payload) {
    Vue.set(state, 'includes', {
      ...state.includes,
      items: payload.data,
      loading: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_INCLUDE_UPDATE_FAILURE](state) {
    Vue.set(state, 'includes', {
      ...state.includes,
      loading: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_INCLUDE_CATEGORIES_PENDING](state) {
    Vue.set(state, 'includeCategories', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_INCLUDE_CATEGORIES_SUCCESS](state, payload) {
    Vue.set(state, 'includeCategories', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_INCLUDE_CATEGORIES_FAILURE](state) {
    Vue.set(state, 'includeCategories', {
      loading: false,
      error: true,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_BANNER_IMAGES_PENDING](state) {
    Vue.set(state, 'bannerImages', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_BANNER_IMAGES_SUCCESS](state, payload) {
    Vue.set(state, 'bannerImages', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_BANNER_IMAGES_FAILURE](state) {
    Vue.set(state, 'bannerImages', {
      loading: false,
      error: true,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_BANNER_IMAGES_SAVE_PENDING](state) {
    Vue.set(state, 'bannerImages', {
      ...state.bannerImages,
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_BANNER_IMAGES_SAVE_SUCCESS](state) {
    Vue.set(state, 'bannerImages', {
      ...state.bannerImages,
      loading: false,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_BANNER_IMAGES_SAVE_FAILURE](state) {
    Vue.set(state, 'bannerImages', {
      ...state.bannerImages,
      loading: false,
      error: true,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_BANNER_IMAGES_LOAD_PENDING](state) {
    Vue.set(state, 'bannerImages', {
      ...state.bannerImages,
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_BANNER_IMAGES_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'bannerImages', {
      ...state.bannerImages,
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_BANNER_IMAGES_LOAD_FAILURE](state) {
    Vue.set(state, 'bannerImages', {
      ...state.bannerImages,
      loading: false,
      error: true,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_MAP_IMAGES_PENDING](state) {
    Vue.set(state, 'mapImages', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_MAP_IMAGES_SUCCESS](state, payload) {
    Vue.set(state, 'mapImages', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_MAP_IMAGES_FAILURE](state) {
    Vue.set(state, 'mapImages', {
      loading: false,
      error: true,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_MAP_IMAGES_SAVE_PENDING](state) {
    Vue.set(state, 'mapImages', {
      ...state.mapImages,
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_MAP_IMAGES_SAVE_SUCCESS](state) {
    Vue.set(state, 'mapImages', {
      ...state.mapImages,
      loading: false,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_MAP_IMAGES_SAVE_FAILURE](state) {
    Vue.set(state, 'mapImages', {
      ...state.mapImages,
      loading: false,
      error: true,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_MAP_IMAGES_LOAD_PENDING](state) {
    Vue.set(state, 'mapImages', {
      ...state.mapImages,
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_MAP_IMAGES_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'mapImages', {
      ...state.mapImages,
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_MAP_IMAGES_LOAD_FAILURE](state) {
    Vue.set(state, 'mapImages', {
      ...state.mapImages,
      loading: false,
      error: true,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_PRICE_INTERVAL_SYNC_PENDING](state) {
    Vue.set(state, 'priceIntervals', {
      ...state.priceIntervals,
      syncing: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_PRICE_INTERVAL_SYNC_SUCCESS](state, payload) {
    Vue.set(state, 'priceIntervals', {
      ...state.priceIntervals,
      syncing: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_PRICE_INTERVAL_SYNC_FAILURE](state) {
    Vue.set(state, 'priceIntervals', {
      ...state.priceIntervals,
      syncing: false,
      error: true,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_PRICE_INTERVALS_GET_PENDING](state) {
    Vue.set(state, 'priceIntervals', {
      ...state.priceIntervals,
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_PRICE_INTERVALS_GET_SUCCESS](state, payload) {
    Vue.set(state, 'priceIntervals', {
      ...state.priceIntervals,
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_PRICE_INTERVALS_GET_FAILURE](state) {
    Vue.set(state, 'priceIntervals', {
      ...state.priceIntervals,
      loading: false,
      error: true,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_PRICE_SETTINGS_SYNC_PENDING](state) {
    state.priceSettings.syncing = true;
    state.priceSettings.error = false;
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_PRICE_SETTINGS_SYNC_SUCCESS](state, payload) {
    Vue.set(state, 'priceSettings', {
      ...state.priceSettings,
      syncing: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_PRICE_SETTINGS_SYNC_FAILURE](state) {
    state.priceSettings.syncing = false;
    state.priceSettings.error = true;
  },

  /**
   * @param state
   */
  [C.ITINERARY_PRICE_SETTINGS_COPY_PENDING](state) {
    state.priceSettings.loading = true;
    state.priceSettings.error = false;
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_PRICE_SETTINGS_COPY_SUCCESS](state) {
    Vue.set(state, 'priceSettings', {
      ...state.priceSettings,
      loading: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_PRICE_SETTINGS_COPY_FAILURE](state) {
    state.priceSettings.loading = false;
    state.priceSettings.error = true;
  },

  /**
   * @param state
   */
  [C.ITINERARY_PRICE_SETTINGS_GET_PENDING](state) {
    Vue.set(state, 'priceSettings', {
      ...state.priceSettings,
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_PRICE_SETTINGS_GET_SUCCESS](state, payload) {
    Vue.set(state, 'priceSettings', {
      ...state.priceSettings,
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_PRICE_SETTINGS_GET_NO_CONTENT](state) {
    Vue.set(state, 'priceSettings', {
      ...state.priceSettings,
      loading: false,
      error: false,
      items: null,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_PRICE_SETTINGS_GET_FAILURE](state) {
    Vue.set(state, 'priceSettings', {
      ...state.priceSettings,
      loading: false,
      error: true,
      items: null,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_PRICES_PENDING](state) {
    Vue.set(state, 'pricesDayProgram', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_DAY_PROGRAM_PRICES_SUCCESS](state, payload) {
    Vue.set(state, 'pricesDayProgram', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_PRICES_FAILURE](state) {
    Vue.set(state, 'pricesDayProgram', {
      loading: false,
      error: true,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_DAY_PROGRAM_PRICES_NO_CONTENT](state) {
    Vue.set(state, 'pricesDayProgram', {
      loading: false,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_CLONE_PENDING](state) {
    state.itinerary.loading = true;
    state.itinerary.error = false;
  },

  /**
   * @param state
   * @param payload
   */
  [C.ITINERARY_CLONE_SUCCESS](state) {
    Vue.set(state, 'itinerary', {
      ...state.itinerary,
      loading: false,
    });
  },

  /**
   * @param state
   */
  [C.ITINERARY_CLONE_FAILURE](state) {
    state.itinerary.loading = false;
    state.itinerary.error = true;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/itinerary/mutations.js